export enum MaterialOrderReportType {
    MaterialOrder = 1,
    Invoice = 2
}